import React from 'react';
import './Tag.css';
import { typeTagNames} from '../../../models/tag_representations';

const TypeTag = ({ reportType, isButton, onButtonClick }) => {
    if (!reportType) return null;

    return (
        <div>
            {isButton ? (
                // <button className={`tag-button ${reportType}`} onClick={() => onButtonClick(reportType)}></button> // TODO: add onClick functionality
                <button className={`tag-button ${reportType}`}>
                    {typeTagNames[reportType]}
                </button>
            ) : (
                <div className={`tag ${reportType}`}>
                    {typeTagNames[reportType]}
                </div>
            )}
        </div>
    );
};

export default TypeTag;
